module.exports = __webpack_public_path__ + "static/media/termopary10ru.e4a7f16e.pdf";